import OHMRepository from './OHMRepository'
import OpointRepository from './OpointRepository'

const repositories = {
    ohm: OHMRepository,
    opoint: OpointRepository
}

export const RepositoryFactory = {
    get: name => repositories[name]
}
